import { createServerFn } from '@tanstack/react-start'

import {
    createFirstSuperUserAccountService,
    getFirstSuperUserSetupStatusService,
} from '@/server/SystemBootstrap/first-super-user.service.ts'

import { createFirstSuperUserAccountInputSchema } from './validation.ts'

export const getFirstSuperUserSetupStatusHandler = createServerFn({
    method: 'GET',
}).handler(async function () {
    return getFirstSuperUserSetupStatusService()
})

export const createFirstSuperUserAccountHandler = createServerFn({
    method: 'POST',
})
    .validator(function (data: unknown) {
        return createFirstSuperUserAccountInputSchema.parse(data)
    })
    .handler(async function ({ data }) {
        return createFirstSuperUserAccountService(data)
    })
